module.exports = __webpack_public_path__ + "img/rm.872a1114.png";